<h2>
  Verbrauchsvergleich
</h2>
<div class="chart-wrap">
  <canvas
    baseChart
    [datasets]="barChartData"
    [labels]="labels"
    [options]="options"
    [chartType]="barChartType"
  >
  </canvas>
</div>
